export const HOST_API_KEY = 'https://api-s.events.mysport.global'
